module.exports = __webpack_public_path__ + "media/images/logos/akt-logo-b0a9e7e313e480a9a6d838a97f5e8552.svg";